<template>
	<div>
		<div class="crumbs">
			<el-breadcrumb separator="/">
				<el-breadcrumb-item :to="{ path: '/classesList' }">
					<i class="el-icon-office-building"></i> 班级管理
				</el-breadcrumb-item>
				<el-breadcrumb-item>更新班级信息</el-breadcrumb-item>
			</el-breadcrumb>
		</div>
		<div class="container">
			<el-form :model="ruleForm" :rules="rules" ref="ruleForm" label-width="180px">
				<el-row>
				  <el-col :span="12">
					<el-form-item :label="'班级ID'" prop="sabMSID">
						<el-input v-model="ruleForm.sabMSID" :disabled="true">></el-input>
					</el-form-item>
				  </el-col>
				 </el-row>
				 <el-row>
				 <el-col :span="24">
				 	<el-form-item :label="'所属幼儿园'" prop="sabSAAI">
				 	<el-select v-model="ruleForm.sabSAAI" clearable 
				 	:placeholder="'请选择幼儿园'" class="handle-select mr10":disabled="true" >
				 	   <el-option
				 		 v-for="item in ruleForm.optionsSAAI"
				 		 :key="item.SAAMSID"
				 		 :label="item.SAANAME"
				 		 :value="item.SAAMSID">
				 	   </el-option>
				 	</el-select>
				 	</el-form-item>
				 </el-col>
				 </el-row>
				 
				<el-row>
				  <el-col :span="12">
					<el-form-item :label="'班级名称'" prop="sabNAME">
						<el-input v-model="ruleForm.sabNAME" :placeholder="'请输入班级名称'" maxlength="20"></el-input>
					</el-form-item>
				  </el-col>
				 </el-row>
				 <el-row>
				   <el-col :span="24">
				   	<el-form-item :label="'所在年级'" prop="sabSADI">
				   	<el-select v-model="ruleForm.sabSADI" clearable 
				   	:placeholder="'请选择年级'" class="handle-select mr10">
				   	   <el-option
				   		 v-for="item in ruleForm.optionsSADI"
				   		 :key="item.SADMSID"
				   		 :label="item.SADNAME"
				   		 :value="item.SADMSID">
				   	   </el-option>
				   	</el-select>
				   	</el-form-item>
				   </el-col>
				  </el-row>
				  <el-row>
				    <el-col :span="24">
				    	<el-form-item :label="'所在教室'" prop="sabSBAI">
				    	<el-select v-model="ruleForm.sabSBAI" clearable 
				    	:placeholder="'请选择教室'" class="handle-select mr10" >
				    	   <el-option
				    		 v-for="item in ruleForm.optionsSBAI"
				    		 :key="item.SBAMSID"
				    		 :label="item.SBANAME"
				    		 :value="item.SBAMSID">
				    	   </el-option>
				    	</el-select>
				    	</el-form-item>
				    </el-col>
				   </el-row>
				<el-row>
				<el-col :span="24">
					<el-form-item :label="'删除状态'" prop="sabDELF">
					<el-select v-model="ruleForm.sabDELF" clearable 
					:placeholder="'请选择删除状态'" class="handle-select mr10">
					   <el-option
						 v-for="item in ruleForm.optionsDELF"
						 :key="item.INIKEY2"
						 :label="item.INIDISP"
						 :value="item.INIKEY2">
					   </el-option>
					</el-select>
					</el-form-item>
				</el-col>
				</el-row>
				<el-row>
					<el-col :span="24">
						<div class="submit">
							<el-form-item>
								<el-button @click="goBack()" class="goback">返回</el-button>
								<el-button type="primary" @click="submitForm('ruleForm')">提交</el-button>
							</el-form-item>
						</div>
					</el-col>
				</el-row>	
			</el-form>
		</div>
	</div>
</template>

<script>
	export default {
		name: 'editClasses',
		inject: ['reload'],
		data() {
			//验证字符串
			const validateFontSize = (rule,value,callback)=>{	
				if (value.toString().length == 0) {
					callback(new Error('请输入班级名称')) //长度在1-20之间
				} else if (value.toString().length < 1 || value.toString().length > 20) {
					callback(new Error('请输入长度在1~20之间的字符')) //长度在1-20之间
				} else {
					this.checkSABNAME(value);
					if (this.isRepeat == true) {
						callback(new Error('班级名称重复'));
					} else {
						callback();
					}
				}
			 }
			return {
				web_sphon: sessionStorage.getItem("ms_username"), //web 登录用户ID
				sabChangeData: {},
				valueSAAI:'',
				ruleForm: {
					sabMSID: '',	
					sabSBAI: '',	
					sabSAAI: '',	
					sabNAME: '',
					sabSADI: '',
					optionsSAAI: [],
					optionsSADI: [],
					optionsSBAI: [],
					sabDELF:''		//状态
				},
				rules: {
					sabNAME: [{
						required: true,
						//message: '请输入班级名称', //'请输入社名称'
						trigger: ['blur', 'change'],
						validator: validateFontSize
					}],
					
					sabDELF:[
						{ 
						 required: true, 
						 message: '请选择删除状态', 
						 trigger:['blur','change']
						}
					],
					sabSAAI:[
						{ 
						 required: true, 
						 message: '请选择幼儿园', 
						 trigger:['blur','change']
						}
					],
					sabSADI:[
						{ 
						 required: true, 
						 message: '请选择年级', 
						 trigger:['blur','change']
						}
					],
					sabSBAI:[
						{ 
						 required: true, 
						 message: '请选择教室', 
						 trigger:['blur','change']
						}
					]
				}
			};
		},
		watch: {
			$route(to, from) {
				if (to.name === "editClasses") {
					this.dummyCreated();
				}
			}
		},
		created() {
			this.sabMSID = this.$route.query.SABMSID;
			this.getData(this.sabMSID);
			this.getSAAI(); 	//幼儿园
			this.getDELF(); //获取删除状态
		},
		mounted() {
			this.$bus.$on('change', () => {
				//刷新当前页面
				this.reload()
			})		
		},
		methods: {
			dummyCreated () {
				this.sabMSID = this.$route.query.SABMSID;
				this.getData(this.sabMSID);
				this.getSAAI(); 	//幼儿园
				this.getDELF(); //获取删除状态
			},
			//获取删除信息
			getDELF(){
				const self_shop = this;
				var postUrl = 'WCF/WEB/svcINI.svc/Get_INI_List';
				//网络请求接口
				this.$axios.post(
					//请求的url
					postUrl,
					//请求参数
					{
						sPHON: self_shop.web_sphon, //web侧 登录邮箱
						sINIKEY1: 10005 //删除 10005
					}
				)
				.then((response) =>{
					//请求成功返回的数据
					let resCount = response.data.KKDTCOUNT;
					if(resCount>0){
						this.ruleForm.optionsDELF= response.data.KKDT;
					}		
				})
				.catch((error) =>{
					this.$message({
					message: '获取删除状态请求失败',  //请求失败
					type: 'error'
					});
				});
			},
			//验证此幼儿园下，班级名称是否重复
			checkSABNAME(value) {
				const self_shop = this;
			
				var postUrl = 'WCF/WEB/svcSAB.svc/CHECK_SAB_NAME';
				//网络请求接口
				this.$axios.post(
					//请求的url
					postUrl,
					//请求参数
					{
						sPHON: self_shop.web_sphon, //web侧 登录邮箱
						sSAAID: self_shop.ruleForm.sabSAAI,
						sSABID: self_shop.ruleForm.sabMSID,
						sSABNM: value
					}
				)
				.then((response) => {
					//请求成功返回的数据
					if (response.data.KKSTR == "Y") {
						this.isRepeat = true;
					} else {
						this.isRepeat = false;
					}
				})
				.catch((error) => {
					this.$message({
						message: '请求失败', //请求失败
						type: 'error'
					});
				});
			},
			//获取幼儿园信息
			getSAAI(){
				const self_shop = this;
				var postUrl='WCF/WEB/svcSAA.svc/Get_SAA_GardenList';
				//网络请求接口
				this.$axios.post(
						//请求的url
						postUrl,
						//请求参数
						{
							sPHON: self_shop.web_sphon //web侧 登录邮箱
						}
					)
					.then((response) =>{
						//请求成功返回的数据
						let resCount = response.data.KKDTCOUNT;
						if(resCount>0){
							this.ruleForm.optionsSAAI= response.data.KKDT;
						}else{
						this.ruleForm.optionsSAAI='';
						this.ruleForm.sabSAAI='';
					}			
					})
					.catch((error) =>{
						this.$message({
						message: '获取幼儿园请求失败',  //请求失败
						type: 'error'
						});
						
					});
			},
			//获取年级信息
			getSAD(valueSAAI){
				const self_agent = this;
				//debugger;
				//console.log(valueSAAI);
				var postUrl='WCF/WEB/svcSAD.svc/GET_SAD_GradeLIST';
				//网络请求接口
				this.$axios.post(
					//请求的url
						postUrl,
					//请求参数
					{ 
						sPHON: self_agent.web_sphon, //web侧 登录ID  tihs.web_suuid
						sSAAI: valueSAAI //web侧 登录ID  tihs.web_suuid
					}
				)
				.then((response) =>{
					//请求成功返回的数据
					let resCount = response.data.KKDTCOUNT;
					if(resCount>0){
						this.ruleForm.optionsSADI= response.data.KKDT;
					}else{
						this.ruleForm.optionsSADI='';
						this.ruleForm.sabSADI='';
					}		
				})
				.catch((error) =>{
					this.ruleForm.sabSADI='';
					this.$message({
					  message: '获取年级信息请求失败',  //请求失败
					  type: 'error'
					});
				});	
			},
			getSBA(valueSAAI){
				const self_agent = this;
				var postUrl='WCF/WEB/svcSBA.svc/Get_SBA_ClassRoomList';
				//网络请求接口
				this.$axios.post(
					//请求的url
						postUrl,
					//请求参数
					{ 
						sPHON: self_agent.web_sphon, //web侧 登录ID  tihs.web_suuid
						sSAAI: valueSAAI
						})
				.then((response) =>{
					//请求成功返回的数据
					let resCount = response.data.KKDTCOUNT;
					if(resCount>0){
						this.ruleForm.optionsSBAI= response.data.KKDT;
					}
					else{
						this.ruleForm.optionsSBAI='';
						this.ruleForm.sabSAAI='';
					}
				})
				.catch((error) =>{
					this.ruleForm.sabSBAI='';
					this.$message({
					message: '获取教室信息请求失败',  //请求失败
					type: 'error'
					});
					
				});
			},
			//获取班级信息
			getData(sabMSID) {
				const self = this;
				var postUrl = 'WCF/WEB/svcSAB.svc/GET_SAB_BYID';
				//网络请求接口
				this.$axios.post(
						//请求的url
						postUrl,
						//请求参数
						{
							sPHON: self.web_sphon, 
							sMSID: sabMSID //会社ID
						}
					)
					.then((response) => {
						//请求成功返回的数据
						let resStatus = response.status;
						if (resStatus == "200") { //网络请求成功
							let resCount = response.data.KKDTCOUNT;
							if (resCount > 0) {
								//返回列信息赋值到页面上 
							self.ruleForm.sabMSID = response.data.KKDT[0].SABMSID;
							self.ruleForm.sabSAAI = response.data.KKDT[0].SABSAAI;
							self.ruleForm.sabSADI = response.data.KKDT[0].SABSADI;
							self.ruleForm.sabSBAI = response.data.KKDT[0].SABSBAI;
							self.ruleForm.sabNAME = response.data.KKDT[0].SABNAME;  
							self.ruleForm.sabDELF = response.data.KKDT[0].SABDELF;
								
							this.sabChangeData = response.data.KKDT[0];
							this.getSAD(self.ruleForm.sadSAAI); 	//年级
							this.getSBA(self.ruleForm.sbaSAAI); 	//教室
							} 
							else {
								this.$message({
									message: '获取数据失败', //无数据
									type: 'error'
								});
							}
						} 
						else {
							this.$message({
								message: '请求获取数据失败', //请求失败
								type: 'error'
							});
						}
					})
					.catch((error) => {
						this.$message({
							message: '请求获取数据失败', //请求失败
							type: 'error'
						});
					});
			},
			//保存会社信息
			submitForm(formName) {
				this.$refs[formName].validate((valid) => {
					if (valid) {
	
						const self = this;
						var valDELF;
						if(self.ruleForm.sabDELF == "undefined")
						{
							valDELF = '';
						}
						else
						{
							valDELF = self.ruleForm.sabDELF;
						}
						var valSADI;
						if(self.ruleForm.sabSADI == "undefined")
						{
							valSADI = '';
						}
						else
						{
							valSADI = self.ruleForm.sabSADI;
						}
						
						var valSBAI;
						if(self.ruleForm.sabSBAI == "undefined")
						{
							valSBAI = '';
						}
						else
						{
							valSBAI = self.ruleForm.sabSBAI;
						}
						
						
						let sabFlag=false;
						if(this.sabChangeData.SABNAME != this.ruleForm.sabNAME)
						{
							sabFlag = true;
						}
						if(this.sabChangeData.sabSBAI != valSBAI)
						{
							sabFlag = true;
						}
						if(this.sabChangeData.sabSADI != valSADI)
						{
							sabFlag = true;
						}
						if(this.sabChangeData.SABDELF != valDELF)
						{
							sabFlag = true;
						}
		
						var postUrl = 'WCF/WEB/svcSAB.svc/UPD_SAB_BYID';
						//网络请求接口
						this.$axios.post(
								//请求的url
								postUrl,
								//请求参数
								{
									sPHON: self.web_sphon,  //web侧 登录ID  tihs.web_suuid
									sMSID: self.sabMSID, //宝宝ID
									sSABNAME: self.ruleForm.sabNAME,  
									sSABSADI: self.ruleForm.sabSADI,
									sSABSBAI: self.ruleForm.sabSBAI,
									sSABDELF: self.ruleForm.sabDELF
								}
							)
							.then((response) => {
								//请求成功返回的数据
								let resStatus = response.status; //200 代表请求成功
								let resKKSTR = response.data.KKSTR;

								if (resStatus == "200") {
									if (resKKSTR == "N") {
										this.$message({
											message: '班级信息更新失败', //编辑失败
											type: 'error'
										});
									} else if (resKKSTR == "Y") {
										this.$message.success('班级信息更新成功'); // 编辑成功
										this.$router.push('/classesList') // 跳转路由到用户列表页
										this.$bus.$emit('change') //子组件可以使用$emit触发父组件的自定义事件

										var indexs;
										for (let i = 0; i < this.COMM.tagsLists.length; i++) {
											if (this.COMM.tagsLists[i].name == "editClasses") {
												indexs = i;
												break;
											}
										}
										this.closeTags(indexs);
									}
								} else {
									this.$message({
										message: '请求更新班级信息失败', //请求失败
										type: 'error'
									});
								}
							})
							.catch((error) => {
								this.$message({
									message: '请求更新班级信息失败', //请求失败
									type: 'error'
								});
							});
					} else {
						this.$message({
							message: '信息更新失败', //表单验证失败
							type: 'error'
						});
						return false;
					}
				});
			},
			// 关闭单个标签
			closeTags(index) {
				const delItem = this.COMM.tagsLists.splice(index, 1)[0];
				const item = this.COMM.tagsLists[index] ? this.COMM.tagsLists[index] : this.COMM.tagsLists[index - 1];
				if (item) {
					delItem.path === this.$route.fullPath && this.$router.push(item.path);
				} else {
					this.$router.push('/');
				}
			},
			//返回
			goBack() {
				this.$router.go(-1);

				var indexs;
				for (let i = 0; i < this.COMM.tagsLists.length; i++) {
					if (this.COMM.tagsLists[i].name == "editClasses") {
						indexs = i;
						break;
					}
				}

				this.closeTags(indexs);
			}
		}
	}
</script>
<style>
	 
	.el-dialog__footer {
		text-align: center;
	}

	.el-dialog__footer button {
		width: 94px;
		height: 36px;
		font-size: 14px;
	}


	/* .el-form-item__error {
		font-size: 14px;
		margin-top: 8px;
	} */
</style>
<style scoped>
	.submit {
		margin-left: 35%;
	}

	.submit button {
		width: 94px;
		height: 36px;
		font-size: 14px;
	}

	.goback {
		margin-right: 15px;
	}

	.el-row {
		margin-top: 5px;
	}

	.el-input {
		width: 90%;
	}

	.el-input--small .el-input__inner {
		height: 36px;
		line-height: 36px;
		font-size: 14px;
		padding-left: 10px;
	}
</style>
